import * as css from 'css/exports.module.scss';

import './Index.scss';

import { CommentSection } from './comments';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { InitiativeDescription } from './Description';
import { InitiativeSidebar } from './sidebar';
import { InitiativeSummary } from './summary';
import { InitiativeTitleBar } from './TitleBar';
import { ScopeSection } from './scopes';
import { TaskSection } from './tasks';
import { useNavigate } from 'react-router-dom';

import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { ScrollShadow, SonarCard } from '@ui/general';
import { useCurrentInitiative, usePeriscopeCount, useSonarSelector } from '@hooks';

export interface InitiativeCardProps {
	initiativeId: number;
}

export const InitiativeCard: React.FC<InitiativeCardProps> = ({ initiativeId }) => {
	const navigate = useNavigate();
	const isErrored = useSonarSelector(useCurrentInitiative.selectors.isErrored);
	const isPeriscopeOpen = Boolean(usePeriscopeCount());
	const initiative = useCurrentInitiative();
	const isLoading = useSonarSelector(useCurrentInitiative.selectors.isRequested) && !initiative;

	useEffect(() => {
		if (isErrored) {
			navigate(FULL_ROUTES.INITIATIVES, { replace: true });
		}
	}, [ isErrored, navigate ]);

	return (
		<ScrollShadow
			scroller='.ant-card-body'
			shadow='.ant-card-head'>
			<SonarCard
				loading={ isLoading }
				title={
					<InitiativeTitleBar
						initiativeId={ initiativeId }
						title={ initiative?.title } />
				}>
				<Row
					gutter={ Number(css.size32) }
					justify='space-between'
					wrap>
					<Col span={ isPeriscopeOpen ? 24 : 20 }>
						<InitiativeDescription
							description={ initiative?.description }
							initiativeId={ initiativeId } />
						<InitiativeSummary initiativeId={ initiativeId } />
					</Col>
					<Col span={ isPeriscopeOpen ? 0 : 4 }>
						<InitiativeSidebar
							assignedTo={ initiative?.assignedTo ?? 0 }
							createdBy={ initiative?.createdBy ?? 0 }
							initiativeId={ initiativeId }
							status={ initiative?.initiativeStatusId } />
					</Col>
				</Row>
				<ScopeSection initiativeId={ initiativeId } />
				<TaskSection initiativeId={ initiativeId } />
				<CommentSection initiativeId={ initiativeId } />
			</SonarCard>
		</ScrollShadow>
	);
};
